import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Margenes} from '../../modelo/producto/margenes';

@Injectable({
  providedIn: 'root'
})
export class MargenesService {

  constructor(private readonly http: HttpClient) { }

  traerMargenes(cli_codigo:string):Observable<any> {
    const params = new HttpParams().set('funcion', 'traerMargenes').set('cli_codigo',cli_codigo);
    return this.http.get(`${environment.url.gestionProducto}`, { params });
  }
  guardarMargenes(margenes:Margenes[]):Observable<any> {
    const body=JSON.stringify(margenes);
    const params = new HttpParams().set('funcion', 'guardarMargenes').set('margenes',body);
    return this.http.get(`${environment.url.gestionProducto}`, { params });
  }
}
